import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

export const getDailyChallenges = createAsyncThunk<any, any>(
  types.GET_DAILY_CHALLENGES,
  async (params: Record<string, any>, { getState }: { getState: any }) => {
    const state = getState() as any;

    const user = state.auth.user;

    const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

    const dailyChallenges = isRootAdmin
      ? await api.getDailyChallenges(params)
      : await api.getSchoolDailyChallenges({
          schoolId: user.schoolId,
          params,
        });

    return dailyChallenges;
  },
);

export const getSchoolDailyChallenges = createAsyncThunk<any, any>(
  types.GET_SCHOOL_DAILY_CHALLENGES,
  async (data: any) => {
    const dailyChallenges = await api.getSchoolDailyChallenges(data);

    return dailyChallenges;
  },
);

export const updateDailyChallengeInListById = createAsyncThunk<any, any>(
  types.UPDATE_DAILY_CHALLENGE_LIST_ITEM,
  async ({
    dailyChallengeId,
    fieldName,
    data,
  }: {
    dailyChallengeId: string;
    fieldName: any;
    data: any;
  }) => {
    const updated = await api.updateDailyChallengeById({
      dailyChallengeId,
      data,
    });

    return { fieldName, updatedDailyChallenge: updated };
  },
);

export const removeDailyChallengeById = createAction(
  types.REMOVE_DAILY_CHALLENGE_BY_ID,
);
